import React, { useCallback, useEffect, useRef, useState } from 'react';
import ImageViewer from 'react-simple-image-viewer';
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import './App.css';
import MyyrTeed from "./assets/svg/Myyr_teed.svg";
import p_monu from "./assets/svg/p_monu.svg"
import r1 from "./assets/svg/r_1.svg"
import r2 from "./assets/svg/r_2.svg"
import r3 from "./assets/svg/r_3.svg"
import r4 from "./assets/svg/r_4.svg"
import r5 from "./assets/svg/r_5.svg"
import r6 from "./assets/svg/r_6 .svg"
import inimesedJson from "./inimesed.json";
import kalmudJson from "./kaart.json";
import './styles.css';

/*
const fs = require('fs').promises;
const path = require('path');
const process = require('process');
import { authenticate } from '@google-cloud/local-auth';
*/

interface Kalm {
    "nr" : number,
    "left" : number,
    "top" : number,
    "width" : number,
    "height" : number,
    "selected"?: boolean
    "hovered"?: boolean,
    "nimed"?: string[]
}

/* inimesed json schema
{
  "type": "array",
  "items": {
    "type": "object",
    "properties": {
      "Nr": {
        "type": ["number","null"]
      },
      "Perekonnanimi": {
        "type": "string"
      },
      "Eesnimi": {
        "type": "string"
      },
      "birth": {
        "type": "string"
      },
      "death": {
        "type": "string"
      },
      "Rida": {
        "type": "string"
      },
      "platsiNr": {
        "type": "string"
      },
      "kalme": {
        "type": ["number","null"]
      },
      "Kalmistu": {
        "type": "string"
      },
      "kirj": {
        "type": "string"
      },
      "tahiseKirj": {
        "type": "string"
      }
    }
  }
}
*/

interface Inimene {
    "Nr": number | null,
    "Perekonnanimi": string,
    "Eesnimi": string,
    "birth": string,
    "death": string,
    "Rida": string,
    "platsiNr": string,
    "kalme": number | null,
    "Kalmistu": string,
    "kirj": string,
    "tahiseKirj": string,
    "taustainf": string,
    "vanalPlaanil": string,
    "fotod": string,
    "KirillitsPerek": string,
    "KirillitsEesnimi": string
}

interface Inim {
    "nimi": string,
    "nimiKiril"?: string,
    "eluaastad": string,
    "tahiseKirj": string,
    "taustainf"?: string,
}

interface Vaste {
    "platsiNr": number,
    "inimesed": Inim[],
    "plats"?: Kalm,
    "Rida": string,
    "kalme": number,
    "Kalmistu": string,
    "kirj": string,
    "vanalPlaanil": string,
    "fotod": string,
}

const Plats = (props: {kalm: Kalm, a: number, clickHandle: (nr: number)=> void, hoverHandle: (kalm: Kalm | false) => void, selectedIs: boolean}) => {
    const [color, setColor] = useState("#679167");
    const [selected, setSelected] = useState(props.selectedIs);
    useEffect(() => {
        setSelect(props.selectedIs);
        //setHovering(false);
    }, [props.selectedIs]);

    const setSelect = (s: boolean) => {
        setSelected(s);
        if (s){
            setColor("#014701");
        }else {
            setColor("#679167");
        }
    }

    const hoverOn = () => {
        if(!selected) {
            setColor("#686868");
        }
        //setHovering((val) => !val);
        props.hoverHandle(props.kalm);

        //console.log("hovering: ", props.kalm.nr, hovering);
    };
    const hoverOff = () => {
        if(!selected) {
            setColor("#679167");
        }
        //setHovering((val) => !val);
        props.hoverHandle(false);
        //console.log("hovering: ", props.kalm.nr, hovering);
    };

    const handleClick = () => {
        setSelect(true);
        props.clickHandle(props.kalm.nr);
    }

    return (
      <>
          <rect className={selected? "rectselekt" : "rectmitteselekt"} onClick={handleClick} onMouseEnter={hoverOn} onMouseLeave={hoverOff} fill={selected? "#014701" : color} x={props.a * props.kalm.left}
                y={props.a * props.kalm.top} width={props.a * props.kalm.width}
                height={props.a * props.kalm.height}
          />

      </>
    );

}

function MapSvg(props: { rects: Kalm[], height: number, width: number, selectedPlats: number, platsClickHandle: (nr: number)=> void, openImageViewer: (nr: number)=> void}) {
    const [selected, setSelected] = useState(props.selectedPlats);
    const [hovering, setHovering] = useState<Kalm | false>(false);

    let a = 1;
    useEffect(() => {
        a = 1;
        setSelected(props.selectedPlats);
    }, [props.selectedPlats, hovering]);


    const platsClick = (nr: number) => {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('plats', nr.toString());
        window.location.search = urlParams.toString();

    }

    let vbox: string = ` 0 0 ${props.width.toString()} ${props.height.toString()}`;

    const hoverHandle = (kalm: Kalm | false): void => {
        setHovering((val) => kalm);
    } ;

    return (
      <div>
          <svg viewBox={vbox}>
              {props.rects.map((kalm) => (
                <Plats key={kalm.nr} kalm={kalm} a={a} clickHandle={platsClick} hoverHandle={hoverHandle} selectedIs={selected===kalm.nr} />
              ))}
              <>
                  <image href={MyyrTeed} width={942} height={props.height}/>
                  <image href={p_monu} x={602} y={66} width={115} height={63} />
                  <rect className="nahtamatu_rect" onClick={() => props.openImageViewer(0)} x={602} y={66} width={115} height={63} />
                  <image href={r1} width={23} x={801} y={831}  height={30}/>
                  <rect className="nahtamatu_rect" onClick={() => props.openImageViewer(1)}width={23} x={801} y={831}  height={30} />
                  <image href={r2} width={23} x={869} y={1057}  height={30}/>
                  <rect className="nahtamatu_rect" onClick={() => props.openImageViewer(2)} width={23} x={869} y={1057}  height={30} />
                  <image href={r3} width={23} x={745} y={1240}  height={30}/>
                  <rect className="nahtamatu_rect" onClick={() => props.openImageViewer(3)}  width={23} x={745} y={1240}  height={30}/>
                  <image href={r4} width={23} x={541} y={1040}  height={30}/>
                  <rect className="nahtamatu_rect" onClick={() => props.openImageViewer(4)}  width={23} x={541} y={1040}  height={30} />
                  <image href={r5} width={23} x={695} y={814}  height={30}/>
                  <rect className="nahtamatu_rect" onClick={() => props.openImageViewer(5)} width={23} x={695} y={814}  height={30} />
                  <image href={r6} width={23} x={627} y={890} height={30}/>
                  <rect className="nahtamatu_rect" onClick={() => props.openImageViewer(6)} width={23} x={627} y={890} height={30}/>
              </>
              <>
                  {hovering ? (
                    <>
                        <text className={"hoverInf"} x={a*hovering.left} y={a*hovering.top} style={{stroke:'\#efe8e4', strokeWidth:"0.2em", pointerEvents: "none", zIndex: 100, fontSize: 27}} >{hovering.nr.toString().replace("0.","")} </text>
                        <text className={"hoverInf1"} x={a*hovering.left} y={a*hovering.top} style={{ pointerEvents: "none", zIndex: 100, fontSize: 27}} >{(hovering.nr).toString().replace("0.","")} </text>
                        {hovering?.nimed?.map((n: string, index) =>
                          <>
                              <text className={"hoverInf2"} x={a*hovering.left} y={(a*hovering.top) - index * 30 - 30} style={{stroke:'\#efe8e4', strokeWidth:"0.2em", pointerEvents: "none", fontSize: 27}}>{n}</text>
                              <text className={"hoverInf3"} x={a*hovering.left} y={(a*hovering.top) - index * 30 - 30} style={{pointerEvents: "none", zIndex: 100, fontSize: 27}}>{n}</text>
                          </>
                        )}
                    </>
                  ) : null}
              </>
          </svg>
      </div>
    );
}

interface Sisend {
    "ees": string,
    "pere": string,
    "synd": string,
    "surm": string
}

function Otsing(props: { handleSubmitOtsi: (s:Sisend | number) => boolean | undefined, inimesed: Inimene[] }) {
    const [sisend, setSisend] = useState({ees: "", pere: "", synd: "", surm: ""});
    const [autoComplete, setAutocomplete] = useState<{ees: JSX.Element[], pere: JSX.Element[], synd: number[], surm: number[]}>({ees: [], pere: [], synd: [], surm: []});
    let arr4autocomplete: Inimene[] = [];
    //const [autocompleteIndexState, setAutocompleteIndexState] = useState<number>(-1);
    let autocompleteIndex = -1;
    let lastIndex = -1;
    let focusedEESNIMI = false;
    //let elementInFocus = null;
    const eesnimRef = React.createRef<HTMLDivElement>();
    const perenimRef = React.createRef<HTMLDivElement>();
    //let autosuggestionsRef: HTMLElement;
    const EES = document.getElementById("ees_items");
    const PERE = document.getElementById("pere_items");
    //const autosuggestionsRef = (): HTMLElement => focusedEESNIMI ? document.getElementById("ees_items") as HTMLElement : document.getElementById("pere_items") as HTMLElement;

    /**
     * Hook that alerts clicks outside of the passed ref
     */
    function useOutsideAlerter(ref: any) {
        useEffect(() => {
            autocompleteIndex = -1;
            //autosuggestionsRef = Array<Element>.prototype.slice.call(document.getElementsByClassName("input")).find((value) => value?.firstChild?.children?.length > 0 || value?.hasFocus()) as HTMLElement;

            /**
             * Alert if clicked on outside of element
             */
            function handleClick(event: { target?: any; keyCode?: number | undefined; preventDefault?: any; }) {
                //console.log('mida me klikime log',event.target.className);
                if(event.target.className === 'suggestion' || event.target.className === 'autocomplete-active'){
                    handleSubmit(event, true);
                }
                setAutocomplete({ees: [], pere: [], synd: [], surm: []})//closes suggestions riba

                /*if (ref.current && !ref.current.contains(event.target)) {
                    alert("You clicked outside of me!");
                }*/
            }
            function handleKeypress2(event: { target?: any; key?: string | undefined; preventDefault?: any; }) {
                focusedEESNIMI = event.target.id === 'perenimi' || false;
                const suggestionsLenght = (focusedEESNIMI ? document.getElementById("ees_items") as HTMLElement : document.getElementById("pere_items") as HTMLElement)?.children?.length;
                //console.log("keypress target classname, focusedEESNIMI?, event, suggestionsLenght", event.target.className, focusedEESNIMI, event, suggestionsLenght);
                if(suggestionsLenght > 0){
                    if (event.key === "ArrowDown") {
                        lastIndex = autocompleteIndex;
                        if (autocompleteIndex+1 >= suggestionsLenght){
                            autocompleteIndex = 0;
                        } else {
                            autocompleteIndex++;
                        }
                    } else if (event.key === "ArrowUp") {
                        lastIndex = autocompleteIndex;
                        if (autocompleteIndex - 1 < 0) {
                            autocompleteIndex = suggestionsLenght -1;
                        } else {
                            autocompleteIndex--;
                        }
                    }else if (event.key !== "Enter"){
                        lastIndex = autocompleteIndex;
                        autocompleteIndex = -1;
                    }
                    if(lastIndex > -1) {
                        // @ts-ignore
                        (focusedEESNIMI ? document.getElementById("ees_items") as HTMLElement : document.getElementById("pere_items") as HTMLElement)?.children.item(lastIndex).setAttribute("class", "suggestion");
                    }
                    if(autocompleteIndex > -1){
                        // @ts-ignore
                        (focusedEESNIMI ? document.getElementById("ees_items") as HTMLElement : document.getElementById("pere_items") as HTMLElement)?.children.item(autocompleteIndex).setAttribute("class", "autocomplete-active");
                    }
                }else{
                    autocompleteIndex = -1;
                }
                if (event.key === "Enter") {
                    event.preventDefault();
                    //setSisend({ees: })
                    if(autocompleteIndex > -1){
                        handleSubmit(event, false, autocompleteIndex);
                    }
                    setAutocomplete({ees: [], pere: [], synd: [], surm: []})//closes suggestions riba
                }
            }
            /*const focusHANDLE = (event: { relatedTarget: any; }) => {
                console.log('newly focused element:', event.relatedTarget);
                //elementInFocus = event.relatedTarget?.parentElement.getElementsByClassName("autocomplete-items")?.item(0);
                elementInFocus = event.relatedTarget;
                if(elementInFocus){ // && elementInFocus !== lastElementInFocus TODO
                    autosuggestionsRef = elementInFocus;
                    setAutocomplete({ees: [], pere: [], synd: [], surm: []})//closes suggestions riba
                }
            }*/
            // Bind the event listener
            document.addEventListener("mousedown", handleClick);
            document.addEventListener("keydown", handleKeypress2);
            //document.addEventListener('focusin', focusHANDLE);
            return () => {
                // Unbind the event listener on clean up
                //document.removeEventListener('focusout', focusHANDLE);
                document.removeEventListener("mousedown", handleClick);
                document.removeEventListener("keydown", handleKeypress2);
            };
        }, [ref]);
    }

    const wrapperRef = useRef(null); //see div kuhu ref= this on imeväike
    useOutsideAlerter(wrapperRef); //ref pole kasutusel hetkel

    const regex = /[абвгдеёжзийклмнопстуфхцчшщъыьэюя]/g;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        autocompleteIndex = -1;
        let suggestionElements: JSX.Element[];

        //console.log(e.target.value);
        switch (e.target.id) {
            case "eesnimi":
                setSisend({ ees: e.target.value, pere: sisend.pere, synd: sisend.synd, surm: sisend.surm});
                const arr_duplic: Inimene[] = props.inimesed.filter((isik)=> isik.Eesnimi && isik.Eesnimi.substr(0, e.target.value.length).toUpperCase() === e.target.value.toUpperCase());
                arr_duplic.forEach(value => {if(arr4autocomplete.indexOf(value) === -1){
                    arr4autocomplete.push(value);
                }  });
                suggestionElements = arr4autocomplete.map((isik, index) => (
                  <div className={"suggestion"}>{isik.Eesnimi.toString() + " " + isik.Perekonnanimi.toString()}
                      <input type="hidden" value={isik.platsiNr}/>
                  </div>
                ));
                setAutocomplete({ ees: suggestionElements, pere: autoComplete.pere, synd: autoComplete.synd, surm: autoComplete.surm});
                break;
            case "perenimi":
                setSisend({ ees: sisend.ees, pere: e.target.value, synd: sisend.synd, surm: sisend.surm});
                if(regex.test(e.target.value)){ //kirillitsas
                    console.log("logz: kirillitsas sisend");
                }
                const arr_duplic2 = props.inimesed.filter((isik)=> isik.Perekonnanimi && isik.Perekonnanimi.substr(0, e.target.value.length).toUpperCase() === e.target.value.toUpperCase());
                arr_duplic2.forEach(value => {if(arr4autocomplete.indexOf(value) === -1){
                    arr4autocomplete.push(value);
                }  });
                suggestionElements = arr4autocomplete.map((isik, index) => (
                  <div className={"suggestion"}>{isik.Eesnimi.toString() + " " + isik.Perekonnanimi.toString()}
                      <input type="hidden" value={isik.platsiNr}/>
                  </div>
                ));
                setAutocomplete({ ees: autoComplete.ees, pere: suggestionElements, synd: autoComplete.synd, surm: autoComplete.surm});
                break;
            case "sund":
                setSisend({ ees: sisend.ees, pere: sisend.pere, synd: e.target.value, surm: sisend.surm});
                setAutocomplete({ees: [], pere: [], synd: [], surm: []});
                arr4autocomplete = [];
                break;
            case "surm":
                setSisend({ ees: sisend.ees, pere: sisend.pere, synd: sisend.synd, surm: e.target.value});
                setAutocomplete({ees: [], pere: [], synd: [], surm: []});
                arr4autocomplete = [];
                break;
        }
    };

    const handleSubmitNoPrevent = (e: React.KeyboardEvent<HTMLInputElement>) => {
        //e.preventDefault();
        if(e.key === "Enter"){
            e.preventDefault();
            handleSubmit(e);
        }
    };

    const handleSubmit = (e: { key?: string; preventDefault?: any; target?: any; }, clickEvent?: boolean, enterEventSuggestionIndex?: number) => {
        if(clickEvent){
            if(e.target?.className === "suggestion"){
                e.preventDefault();
                console.log("Otsing click suggestion - ", parseInt(e.target?.children?.item(0).value), e.target?.children?.item(0));
                props.handleSubmitOtsi(parseInt(e.target?.children?.item(0).value));
                setSisend({ees: "", pere: "", synd: sisend.synd, surm: sisend.surm});//pead display updatema
            }
        }
        //else if ( e.key === "Enter" && enterEventSuggestionIndex && enterEventSuggestionIndex > -1 && arr4autocomplete.length > 0) { // if autocomplete mingeid itemeid on
        if (enterEventSuggestionIndex){
            e.preventDefault();
            focusedEESNIMI = e.target.id === 'perenimi' || false;
            const kalmuNr = ((focusedEESNIMI ? document.getElementById("ees_items") as HTMLElement : document.getElementById("pere_items") as HTMLElement)?.children?.item(enterEventSuggestionIndex)?.lastChild as HTMLInputElement); //autoComplete.ees.concat(autoComplete.pere).filter();
            console.log("Otsing enter suggestion - ",  kalmuNr, arr4autocomplete, enterEventSuggestionIndex, document.getElementById("pere_items")?.children[enterEventSuggestionIndex]); //TODO
            if(parseInt(kalmuNr.value)) {
                e.preventDefault();
                setSisend({ees: arr4autocomplete.find((i, index) => index === enterEventSuggestionIndex)?.Eesnimi || sisend.ees, pere: arr4autocomplete.find((i, index) => index === enterEventSuggestionIndex)?.Perekonnanimi || sisend.pere, synd: sisend.synd, surm: sisend.surm});//pead display updatema
                props.handleSubmitOtsi(parseInt(kalmuNr.value)); //({ees: autoComplete.ees. });
            }else{
                console.log("ei ole seda nr: ", kalmuNr);
            }
        }
        const syndInputValue = (document.getElementById("sund") as HTMLInputElement).value;
        const surmInputValue = (document.getElementById("surm") as HTMLInputElement).value;
        const eesInputValue = (document.getElementById("eesnimi") as HTMLInputElement).value;
        const pereInputValue = (document.getElementById("perenimi") as HTMLInputElement).value;
        if(syndInputValue || surmInputValue || eesInputValue || pereInputValue){
            const parisSisend = {ees: eesInputValue || sisend.ees, pere: pereInputValue || sisend.pere, synd: syndInputValue || sisend.synd, surm: surmInputValue || sisend.surm };
            //setSisend(parisSisend);
            //console.log("Otsing - ", parisSisend, e);
        }

        if(props.handleSubmitOtsi(sisend)){
            //console.log('logz: sain vastuse handlesubmitotsi')
            e.preventDefault();
            //setSisend({ees: "", pere: "", synd: "", surm: ""});//pead display updatema
        }
        autocompleteIndex = -1;

    };

    const liStyle = {
        marginLeft: 0
    };

    const focusEesnim = (elementInFocus: React.FocusEvent<HTMLDivElement>)=>{
        console.log(eesnimRef.current as unknown as HTMLElement);
        //autosuggestionsRef = eesnimRef.current as unknown as HTMLElement;
        //setFocusEesnimi(true);
        focusedEESNIMI = true;
        //autosuggestionsRef = elementInFocus.target?.id === "perenimi" ? document.getElementById("ees_items") as HTMLInputElement : document.getElementById("pere_items") as HTMLInputElement;
        setAutocomplete({ees: [], pere: [], synd: [], surm: []})//closes suggestions riba
    }
    const focusPerenimi = (elementInFocus: any)=>{
        console.log(perenimRef.current as unknown as HTMLElement);//TODO MIKS EI LÄHE REF ÕIGEKS
        //setFocusEesnimi(false);
        focusedEESNIMI = false;
        //autosuggestionsRef() = perenimRef.current as unknown as HTMLElement;

        setAutocomplete({ees: [], pere: [], synd: [], surm: []})//closes suggestions riba
    }

    return(
      <div className="form">
          <ul className={"searchUl"}>
              <li style={liStyle} className="korvuti_li">
                  <label className="sisu" htmlFor="pnimi">
                      Perekonnanimi:{" "}
                  </label>
                  <form autoComplete="off">
                      <div className="autocomplete" onFocus={(elementInFocus) => focusPerenimi(elementInFocus)}>
                          <input style={{width: 170}} value={sisend.pere} onChange={(e)=> handleChange(e)} id="perenimi" type="text" className="input"/>
                          <div id="ees_items" ref={eesnimRef} className="autocomplete-items">
                            {autoComplete.pere}
                          </div>
                      </div>
                  </form>
              </li>
              <li className="korvuti_li">
                  <label className="sisu" htmlFor="enimi">
                      Eesnimi:{" "}
                  </label>
                  <form autoComplete="off" >
                      <div className="autocomplete" onFocus={(elementInFocus) => focusEesnim(elementInFocus)}>
                          <input style={{width: 170}} value={sisend.ees} onChange={(e)=> handleChange(e)} id="eesnimi" type="text" className="input"/>
                          <div id="pere_items" ref={perenimRef} className="autocomplete-items">
                            {autoComplete.ees}
                          </div>
                      </div>
                  </form>
              </li>
              <li className="korvuti_li">
                  <label className="sisu" htmlFor="sund">
                      Sünniaasta:{" "}
                  </label>
                  <div>
                      <input value={sisend.synd} onKeyPress={(e) => handleSubmitNoPrevent(e)} onChange={(e)=> handleChange(e)}
                             type="text"
                             id="sund"
                             className="input"
                             style={{width: 120}}
                      />
                  </div>
              </li>
              <li className="korvuti_li">
                  <label className="sisu" htmlFor="surm">
                      Surmaaasta:{" "}
                  </label>
                  <div>
                      <input value={sisend.surm} onKeyPress={(e) => handleSubmitNoPrevent(e)} onChange={(e)=> handleChange(e)}
                             type="text"
                             id="surm"
                             className="input"
                             style={{width: 120}}
                      />
                  </div>
              </li>
              <button onClick={(e)=> handleSubmit(e)} className="nupp">Otsi</button>
          </ul>
      </div>
    );
}

function Tulemus(props: {vaste: Vaste, inimesed: Inimene[], pildid: string[], vasteGo: (nr: number)=>void}) {
    //let tulemus_platsid: Vaste[] = [props.vaste];
    //let tulemus_inimesed: Inimene[] = props.inimesed;
    const [vaste, setTulemus_plats] = useState(props.vaste);
    const [tulemus_inimesed, setTulemus_inimesed] = useState(props.inimesed);
    const [pildid, setpildid] = useState(props.pildid);


    useEffect(() => {
        setTulemus_plats(props.vaste);

        console.log('useEffect logic ran: vaste updated');
    }, [props.vaste]);

    useEffect(() => {
        setTulemus_inimesed(props.inimesed);

        console.log('useEffect logic ran: inimesed updated');
    }, [props.inimesed]);

    useEffect(() => {
        setpildid(props.pildid);

        console.log('useEffect logic ran: pildid updated');
    }, [props.pildid]);



    const handleClickInTulemusteList = (nr: number) => {
        props.vasteGo(nr);
    }

    const openVanaPlaan = () => {
        console.log("vana plaan");
    }

    if(!vaste && tulemus_inimesed?.length < 1){
        return (
          <div id="tulemus">
              <p className="mine">Sobivaid tulemusi ei leitud.</p>
          </div>
        );
    }
    if(tulemus_inimesed.length > 1){
        return (
          <div>
              <p className="väike">Leitud vasted:</p>
              {tulemus_inimesed.map((kalm, index)=> (
                <>{(index === 0 || tulemus_inimesed[index-1].platsiNr !== kalm.platsiNr) && <p>{"Plats "+kalm.platsiNr.toString()}</p>}
                    <li className="vajuta" key={index}
                        onClick={() => handleClickInTulemusteList(parseInt(kalm.platsiNr))}>{
                      kalm.Eesnimi + " " + kalm.Perekonnanimi + ", " + kalm.birth.replace("/*/*", "").replace("/**/**", "")
                      + " - " + kalm.death.replace("/*/*", "").replace("/**/**", "")
                    }</li>
                </>
              ))}
          </div>
        );
    }
    if(vaste?.platsiNr) {
        return (
          <div id="tulemus">
              {vaste?.Rida ? <p>{"Plats nr " + vaste.platsiNr.toString() + ", rida " + vaste.Rida}</p> :
                <p>{"Plats nr " + vaste.platsiNr.toString()}</p>}
              {(vaste.vanalPlaanil !== "undefined." && vaste.vanalPlaanil?.length > 0) &&
                <p style={{marginTop: 10}}>{vaste.vanalPlaanil}</p>}
              {vaste.vanalPlaanil !== "undefined." && vaste.vanalPlaanil && vaste.vanalPlaanil !== 'Vanal plaanil asukoht tuvastamata..' &&
                <p style={{marginBottom: 15, marginTop: -15, textDecoration: "underline"}} className="vajuta"
                   onClick={() => openVanaPlaan()}>Vaata 1957 a. plaani.</p>
              }
              <p style={{marginTop: 10}}>{vaste.kirj}</p>
              <div style={{marginBottom: 15}}>
                  {vaste.inimesed.map((inim, index) =>
                    <div key={index}>
                        <p style={{marginBottom: 0, marginTop: 0}}><b>{inim.nimi}</b>{inim.eluaastad}</p>
                        <p>{inim.taustainf}</p>
                        <p>{inim.tahiseKirj}</p>
                    </div>
                  )}
              </div>
              <Pildid pildid={pildid}/>
          </div>
        );
    }
    return (<div></div>);
}

function importAll(r: { (arg0: string): any; (arg0: string): any; keys: any; }) {
    let images: { [x: string]: any; } = {};
    r.keys().forEach((item: string, index: any) => {
        images[item.replace("./","")] = r(item); });
    return images;
}
const images = importAll(require.context('./assets', false, /\.(PNG|png|jpe?g|JPG|svg)$/));
//console.log(images);

function Pildid(props: {pildid: string[]}){
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);

    const openImageViewer = useCallback((index: React.SetStateAction<number>) => {
        setCurrentImage(index);
        setIsViewerOpen(true);
    }, []);

    const closeImageViewer = () => {
        setCurrentImage(0);
        setIsViewerOpen(false);
    };

    const [p, setP] = useState(props.pildid);

    useEffect(() => {
        setP(props.pildid);

        console.log('useEffect logic ran');
    }, [props.pildid]);

    return (
      <div key={29478}>
          <div key={98} style={{display: "tablerow", textAlign: "left"}}>
              {p.map((src, index) => (
                <div className="pilt_kast">
                    <img key={index} onClick={ () => openImageViewer(index) } className="pilt" src={images[src.replace('./assets/images/','')]} alt={src.replace('./assets/images/','')} />
                </div>
              ))}
          </div>
          {isViewerOpen && (
            <ImageViewer
              backgroundStyle={{backgroundColor: "rgba(0,0,0,0.75)"}}
              src={ props.pildid.map((src)=> (images[src.replace('./assets/images/','')])) }
              currentIndex={ currentImage }
              disableScroll={ false }
              closeOnClickOutside={ true }
              onClose={ closeImageViewer }
            />
          )}
      </div>
    );
}

//POST function
async function postData(url: string, data : { kalmistu: string, otsitud_platsi_nr: string, ees: string, pere: string, synd: string, surm: string, leiti_vaste: string}) { // HTMLFormElement TODO


    function getFormData(object: { kalmistu: string, otsitud_platsi_nr: number, ees: string, pere: string, synd: string, surm: string, leiti_vaste: boolean}) {
        const formData = new FormData();
        Object.keys(object).forEach(key => formData.append(key, object[key as keyof { kalmistu: string, otsitud_platsi_nr: number, ees: string, pere: string, synd: string, surm: string, leiti_vaste: boolean}] as string));
        return formData;
    }
    const body = JSON.stringify(data);
    //console.log('logz body',body);
    // Default options are marked with *
    return await fetch(url, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'no-cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json'
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: body // body data type must match "Content-Type" header
    }); // parses JSON response into native JavaScript objects
}

function App() {
    const searchParams = new URLSearchParams(document.location.search);
    const platsiNrnFromURL = searchParams.get('plats');

    const inimesed: Inimene[] = inimesedJson;
    let kalmud_temp: Kalm[] = kalmudJson;
    const kalmud: Kalm[] = kalmud_temp.map<Kalm>((kalm: Kalm): Kalm => { return {
        height: kalm.height,
        hovered: kalm.hovered,
        left: kalm.left,
        selected: kalm.selected,
        top: kalm.top,
        width: kalm.width,
        nimed: inimesed.filter((i: Inimene) => parseFloat(i.platsiNr) === kalm.nr).map((i: Inimene)=>i.Eesnimi + " " + i.Perekonnanimi),
        nr: kalm.nr
    }}) as Kalm[];

    //console.log("logz kalmud ",kalmud);
    const Otsi = (s:Sisend | number): boolean | undefined => {
        if(typeof s === 'number'){
            tulemus = [];
            setTulemus(tulemus);
            setVaste([]);
            //console.log("ba",s);
            VasteGo(s);
            return;
        }
        //console.log(s);
        const Eesnim = s.ees.charAt(0).toUpperCase() + s.ees.slice(1);
        const Perenim = s.pere.charAt(0).toUpperCase() + s.pere.slice(1);
        const empty = [s.ees.length === 0, s.pere.length === 0, s.synd.length === 0, s.surm.length === 0]
        if (s.ees || s.pere || s.synd || s.surm){
            //POST otsinguväljad kui midagi on kirjutatud sinna
            postData('https://script.google.com/macros/s/AKfycbzR2xCV1Bbd-Hx2Yv4CzCB9aOVF7HTlrSm9s90SHTa5f_s0Yo362A982honwC_TUnUfww/exec', { kalmistu: 'Saalessa', otsitud_platsi_nr: '', ees: s.ees, pere: s.pere, synd: s.synd, surm: s.surm , leiti_vaste: 'pending'})
              .then((data) => {
                  console.log('väljad otsing POST: ',data);
              }).catch(err => console.log('POST väljad error: ',err));
            if (s.ees+s.pere !== "") {
                //list kõigist nimetutest
                if(["nimeta", "nimetu"].includes(s.ees.toLowerCase()) || ["nimeta", "nimetu"].includes(s.pere.toLowerCase())){
                    let nimetud = inimesed.filter((i) => (
                      (["nimeta", "nimetu", Perenim].includes(i.Perekonnanimi.toLowerCase()) || ["nimeta", "nimetu", Eesnim].includes(i.Eesnimi.toLowerCase())
                        || i.Eesnimi.toLowerCase().includes("nimeta") || i.Eesnimi.toLowerCase().includes("nimetu") || i.Perekonnanimi.toLowerCase().includes("nimeta") || i.Perekonnanimi.toLowerCase().includes("nimetu"))
                    ));
                    if (nimetud.length === 1) {
                        setVaste([]);
                        VasteGo(parseInt(nimetud[0].platsiNr));
                    }else{
                        setTulemus(nimetud);
                        if(nimetud.length > 1){
                            return true; //clear input fields
                        }
                    }
                }
                //match?
                let tulem = inimesed.filter((i) => (
                  (((i.Eesnimi === Eesnim || empty[0]) && (i.Perekonnanimi === Perenim || empty[1])) || //eesti keeles
                  ((i.KirillitsEesnimi === Eesnim || empty[0]) && (i.KirillitsPerek === Perenim || empty[1]))) && //kirill
                  (i.birth === s.synd || i.birth.slice(0, 4) === s.synd.slice(0, 4) || empty[2]) &&
                  (i.death === s.surm || i.death.slice(0, 4) === s.surm.slice(0, 4) || empty[3])
                ));
                //täpne match (isik) leiame kalmunumbri
                const platsiNrid: Set<string> = new Set(tulem.map(i=>i.platsiNr));
                if(platsiNrid.size === 1){
                    //kõik sama kalmunumbriga isikud
                    console.log("plats nr: "+platsiNrid.values().next().value);
                    setVaste([]);
                    VasteGo(parseInt(platsiNrid.values().next().value));
                }else if(platsiNrid.size > 1) {
                    setTulemus(tulem);
                }else {
                    //this.otsitud = 0;
                    setVaste([]);
                    //this.Vaste(this.kalmunumber)
                }

            } else { //aastaarvude järgi
                let nimed = inimesed.filter((i) => (
                  (s.synd === i.birth || s.synd === i.birth.slice(0, 4) || empty[2]) && (s.surm === i.death || s.surm === i.death.slice(0, 4) || empty[3])
                ));
                if (nimed.length === 1) {
                    setVaste([]);
                    VasteGo(parseInt(nimed[0].platsiNr));
                }else{
                    setTulemus(nimed);
                }
                //this.otsitud = this.nimed.length
            }
        }
    };

    let vaste: Vaste = {
        Kalmistu: "",
        Rida: "",
        fotod: "",
        inimesed: [],
        kalme: 0,
        kirj: "",
        plats: undefined,
        platsiNr: 0,
        vanalPlaanil: ""
    };
    let tulemus: Inimene[] = [];
    const pildid: string[] = [];
    const pildidyle3: string[] = [];

    const [vaste1, setVaste] = useState([vaste]);
    const [tulemus1inimesed, setTulemus] = useState(tulemus);
    const [pildidState, setPildid] = useState(pildid);

    const [selectedPlats, setSelectedPlats] = useState(-1);

    const VasteGo = (platsiNr: number, fromURL=false) => {
        //setVaste([]);
        //setTulemus([]);
        //let tulem = {"rida":0}
        vaste.platsiNr = platsiNr;
        console.log("PLATS: "+platsiNr);
        tulemus = inimesed.filter((i) => (
          parseInt(i.platsiNr) === platsiNr
        ));
        if(tulemus1inimesed.length === 0) {
            tulemus = inimesed.filter((i) => (
              parseInt(i.platsiNr) === platsiNr
            ));
            //setTulemus(tulemus);
            //setVaste([vasteTYHI]);
            vaste.inimesed = [];
            //console.log("a",vaste);
            //console.log("tulemus",tulemus);
        }else{
            setTulemus([]);
        }

        if (tulemus.length === 0) {
            //this.otsitud = 0
            setTulemus([]);
            setVaste([]);
        } else {
            //setTulemus([]);
            for (let i = 0; i < tulemus.length; i++) {
                const nimi = JSON.stringify(tulemus[i].Eesnimi).replace(/"/g, "") + " " + JSON.stringify(tulemus[i].Perekonnanimi).replace(/"/g, "").replace("NIMETA","Nimeta");
                const kalmu_kirjeldus = tulemus[i].tahiseKirj;
                let syndtmp = JSON.stringify(tulemus[i].birth).replace(/"/g, "").split("/");
                let surmtmp = JSON.stringify(tulemus[i].death).replace(/"/g, "").split("/");
                let syndtmp2 = "";
                if (syndtmp[2]) { //& syndtmp[2] != "*") {
                    syndtmp2 += syndtmp[2]+".";
                }
                if (syndtmp[1]) {// & syndtmp[1] != "*") {
                    syndtmp2 += syndtmp[1]+".";
                }
                if (syndtmp[0]) {// & syndtmp[0] != "*") {
                    syndtmp2 += syndtmp[0];
                }
                let surmtmp2 = "";
                if (surmtmp[2]) {// & surmtmp[2] != "*") {
                    surmtmp2 += surmtmp[2]+".";
                }
                if (surmtmp[1]) {// & surmtmp[1] != "*") {
                    surmtmp2 += surmtmp[1]+".";
                }
                if (surmtmp[0]) {// & surmtmp[0] != "*") {
                    surmtmp2 += surmtmp[0];
                }
                //console.log(surmtmp);
                const eluaastad = " " + syndtmp2.replace("*.*.","").replace("**.**.","") +" - "+ surmtmp2.replace("*.*.","").replace("**.**.","");

                vaste.inimesed.push({ nimi: nimi, eluaastad: eluaastad, tahiseKirj: kalmu_kirjeldus});
            }

            let pildid1 = JSON.stringify(tulemus.find((t)=> t.fotod )?.fotod || '').replace(/"/g, "").replace(" ", "").slice(0, -1).split(";");
            let i = 0
            while (i < pildid1.length) {
                if (pildid1[i].trim() !== "") {
                    console.log(i, pildid1[i].trim())
                    if (i < 3) {
                        pildid[i] = pildid1[i].trim() + ".jpg";
                        console.log(pildid[i]);
                    } else {
                        pildidyle3[i-3] = pildid1[i].trim() + ".jpg";
                        console.log(pildidyle3[i-3]);
                        //console.log(pildid1[i].trim())
                    }
                }
                i++;
            }
            setPildid(pildid.concat(pildidyle3));

            vaste.kirj = tulemus.find((t)=> JSON.stringify(t.kirj).replace(/"/g, "") !== "")?.kirj || "";
            vaste.vanalPlaanil = tulemus.find((t)=> JSON.stringify(tulemus[0].vanalPlaanil).replace(/"/g, "") !== "")?.vanalPlaanil +"." || "";
            vaste.Rida = tulemus.find((t)=> t.Rida)?.Rida || "";
            /*
            if (this.kirjeldused.length === 0) {
                this.kirjeldused.push("Kirjeldus/info puudub.")
                this.kirjeldused.push("")
            }// else {
            //this.kirjeldus = this.kirjeldus.charAt(0).toUpperCase() + this.kirjeldus.slice(1)
            //}
            console.log(this.kirjeldused[1])*/
            //this.otsitud = 1

            //kaardi offset platsi järgi
            let kalm = kalmud.find((k) => (
              k.nr === platsiNr
            ));
            //console.log("3 "+kalm);
            if(kalm){
                vaste.plats = kalm;
                setSelectedPlats(kalm.nr);
            }
            //console.log(vaste);
            setVaste([vaste]);
            if (!fromURL){
                const s1 = {ees: tulemus[0].Eesnimi, pere: tulemus[0].Perekonnanimi, synd: tulemus[0].birth, surm: tulemus[0].death};
                if(tulemus){ //POST data kui lihtsalt platsi nr
                    postData('https://script.google.com/macros/s/AKfycbzR2xCV1Bbd-Hx2Yv4CzCB9aOVF7HTlrSm9s90SHTa5f_s0Yo362A982honwC_TUnUfww/exec', { kalmistu: 'Saalessa', otsitud_platsi_nr: platsiNr.toString(), ees: s1.ees, pere: s1.pere, synd: s1.synd, surm: s1.surm , leiti_vaste: 'true'})
                      .then((data) => {
                          console.log('platsi nr otsing POST: ',data);
                      }).catch(err => console.log('POST error: ',err));
                }
            }

        }//tulemused/tulemus
    }

    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(images['p_monu']);
    const interact_pildid = [images['p_monu.JPG'], images['r_1.JPG'], images['r_2.JPG'],images['r_3.JPG'],images['r_4.JPG'],images['r_5.JPG'],images['r_6.JPG'],];

    const openImageViewer = useCallback((index: number) => {
        setCurrentImage(interact_pildid[index]);
        setIsViewerOpen(true);
    }, []);

    const closeImageViewer = () => {
        setIsViewerOpen(false);
    };useEffect(() => {
        // platsiNrnFromURL = null;
        VasteGo(Number(platsiNrnFromURL), true);
    }, [platsiNrnFromURL]);

    //1.53375 suhe 1227 ja 800 vahel
    return (
      <div>
          <div id="otsingu_osa">
              <div style={{marginLeft: 20}}>
                  <p className="väike" style={{marginBottom: 5, marginTop: 10}}>Otsi kalmu</p>
                  <Otsing handleSubmitOtsi={ Otsi } inimesed={inimesed}/>
              </div>
              <hr/>
              <div style={{marginLeft: 20}}>
                  <Tulemus inimesed={tulemus1inimesed} vaste={vaste1[0]} pildid={pildidState} vasteGo={VasteGo} />
              </div>
          </div>
          <div className={"väikekaart"}  id={"svgkaart"}>
              <TransformWrapper initialScale={1} limitToBounds={false} centerZoomedOut={true}>
                  {({ zoomIn, zoomOut, resetTransform, zoomToElement, ...rest }) => (
                    <React.Fragment>
                        <TransformComponent  >
                            <MapSvg height={1385} width={943} rects={kalmud} selectedPlats={selectedPlats} platsClickHandle={VasteGo} openImageViewer={openImageViewer
                            } />
                        </TransformComponent>
                    </React.Fragment>
                  )}
              </TransformWrapper>
          </div>
          {isViewerOpen && (
            <ImageViewer
              backgroundStyle={{backgroundColor: "rgba(0,0,0,0.75)"}}
              src={ [currentImage] }
              disableScroll={ true }
              closeOnClickOutside={ true }
              onClose={ closeImageViewer }
            />
          )}
      </div>
    );
}

export default App;
